import React from 'react';
import * as GlobalConfig from "../../constants/GlobalConfig";
import log from 'components/utils/Logger';

class App extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: true
        };
    };

    componentDidMount() {
        const key = GlobalConfig.TENANT_KEY;
        import(`scss/${key}/map.css`);
        import(`containers/plugin/${key}/Map`)
            .then((module) => {
                return this.setState({
                    module: module.default,
                });
            })
            .catch((e) => {
                return console.log(e);
            });
    };

    render () {
        const {module: Component} = this.state;
        return (
            <div>
                {Component && <Component />}
                <span style={{position:"absolute",left: 0,bottom:0,color:"#DED4C0"}}>{GlobalConfig.VersionName} {GlobalConfig.TENANT_KEY}</span>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/map/MapLoader.js